import { render, staticRenderFns } from "./SectionColumn.vue?vue&type=template&id=0dfa4235&"
import script from "./SectionColumn.vue?vue&type=script&lang=js&"
export * from "./SectionColumn.vue?vue&type=script&lang=js&"
import style0 from "./SectionColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports